<template>
  <v-application v-if="access.item_categories">
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-card :loading="data_loading" class="pl-5">
          <v-toolbar flat>
            <v-btn
              v-if="access.create_good_category"
              class="mr-1"
              tile
              color="success"
              to="/items/categories/create"
            >
              <v-icon color="white">mdi-plus</v-icon>
              <div class="text-color">Add category</div>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="!canDrag"
              class="mr-1"
              icon
              large
              color="success"
              @click="action('change')"
            >
              <v-icon color="green">mdi-swap-vertical-bold</v-icon>
              <!-- <div class="text-color">Change</div> -->
            </v-btn>
            <v-btn
              @click="action('done')"
              icon
              large
              v-if="canDrag"
              color="success"
            >
              <v-icon> mdi-check </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="action('close')"
              large
              v-if="canDrag"
              color="error"
            >
              <v-icon> mdi-close </v-icon>
            </v-btn>
            <v-btn
              v-if="selected.length !== 0"
              text
              color="error"
              v-on:click="remove"
            >
              <v-icon>mdi-delete</v-icon>
              {{ $t("delete") }}
            </v-btn>
          </v-toolbar>

          <v-treeview
            v-if="!canDrag"
            v-model="selected"
            v-bind:items="all_categories"
            selectable
            return-object
            selection-type="leaf"
            hoverable
            selected-color="primary"
            item-key="_id"
          >
            <template #append="{ item }">
              <v-btn
                icon
                v-on:click="
                  $router.push({
                    path: '/items/categories/update',
                    query: { id: item._id },
                  })
                "
              >
                <v-icon>mdi-pen</v-icon>
              </v-btn>
            </template>
          </v-treeview>
          <v-treeview
            v-else
            selectable
            return-object
            selection-type="leaf"
            hoverable
            selected-color="primary"
            item-key="_id"
            :loading="data_loading"
          >
            <v-draggable-treeview v-model="categoriesForDrag" />
          </v-treeview>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Categories from "../../mixins/items/categories";
export default {
  name: "Categories",
  mixins: [Categories],
  data: () => ({
    canDrag: false,
    selected: [],
    categoriesForDrag: [],
  }),
  methods: {
    dragChange() {
      if (!this.canDrag) this.canDrag = !this.canDrag;
    },
    async action(e) {
      if (e === "change") {
        this.canDrag = true;
        return;
      }
      if (e === "done") {
        // send sorted
        let position = 1;
        const categories = this.categoriesForDrag;
        const readyCategories = [];
        for (const c of categories) {
          let cPosition = 1;
          for (const ch of c.children) {
            readyCategories.push({
              _id: ch.id,
              draggable_position: cPosition++,
            });
          }
          readyCategories.push({
            _id: c.id,
            draggable_position: position++,
          });
        }
        await this.categoriesUpdateByPosition(readyCategories);
      }
      await this.categorySortedByPosition();
      this.canDrag = false;
    },
    async remove() {
      var indices = [];
      for (const index in this.selected) {
        indices.push(this.selected[index]._id);
      }
      this.all_categories = [];
      await this.$communicator("delete_category", {
        params: {
          indexes: indices,
        },
      });
      this.$toast.success("Success", { timeout: 2000 });
      this.categorySortedByPosition();
    },
  },
  mounted() {
    this.categorySortedByPosition();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
  watch: {
    canDrag() {
      if (this.canDrag) {
        const categoriesForDrag = [];
        for (const c of this.all_categories) {
          if (!c.children?.length) {
            categoriesForDrag.push({
              id: c._id,
              name: c.name,
              children: [],
            });
            continue;
          }
          const children = [];
          for (const ch of c.children) {
            children.push({
              id: ch._id,
              name: ch.name,
              children: [],
            });
          }
          categoriesForDrag.push({
            id: c._id,
            name: c.name,
            children,
          });
        }
        this.categoriesForDrag = categoriesForDrag;
      }
    },
    all_categories: {
      deep: true,
      handler() {
      },
    },
  },
};
</script>

<style>
.text-color {
  color: #fff;
}
</style>